<template>
  <modal name="add-orderItem-modal" @before-open="beforeOpen" :resizable="true" transition="pop-out"
         :width="500"
         :height="250">
    <h4 class="text-center panel-heading">{{$t('add_product_to_orders')}}</h4>
    <div class="row">
      <div class="col-sm-12">
        <div class="col-sm-12">
          <p class="text-center">{{$t('article_number_should_match')}}</p>
        </div>
      </div>
    </div>
    <form @submit.prevent="addProduct()">
      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-12 mb-20">
            <label>{{$t('article_number')}}</label>
            <input type="text"
                   class="form-control"
                   required
                   v-model="orderItem.articleNumber">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-4">
            <button type="submit" class="btn btn-danger">{{$t('add')}}</button>
          </div>
        </div>
      </div>
    </form>
  </modal>
</template>
<script>
  import {mapGetters} from 'vuex'
  import * as types from '../../store/mutation-types'

  export default {
    name: 'AddOrderItem',
    data () {
      return {
        orderItem: {
          articleNumber: '',
          customerId: ''
        }
      }
    },
    methods: {
      beforeOpen (event) {
        if (event.params.customerId) {
          this.orderItem.customerId = event.params.customerId
        }
      },
      addProduct () {
        this.$store.commit(types.SET_ORDER_ITEM_TO_CREATE, this.orderItem)
        this.$store.dispatch('createOrderItem').then(() => {
          if (this.isOrderItemCreated) {
            this.orderItem.articleNumber = ''
            this.$notify({group: 'success', type: 'success', title: 'Succes', text: 'Artikel is toegevoegd aan mijn orders!'})
            this.$modal.hide('add-orderItem-modal')
          } else {
            this.$notify({group: 'danger', type: 'error', title: 'Error', text: 'Dit artikelnummer bestaat niet!'})
          }
        })
      }
    },
    computed: {
      ...mapGetters({
        isOrderItemCreated: 'isOrderItemCreated'
      })
    }
  }
</script>

<style scoped>
  .mb-20 {
    margin-bottom: 20px;
  }
</style>
